import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=0e315388&"
import script from "./selectType.vue?vue&type=script&lang=ts&"
export * from "./selectType.vue?vue&type=script&lang=ts&"
import style0 from "./selectType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports